/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './profile.defs.js'
export * as $defs from './profile.defs.js'
